import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';

function formatDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear());
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} - ${hours}:${minutes}`;
}

@Injectable({ providedIn: 'root' })
export class MixpanelHelper {
  constructor() {}

  login(userName: string, userCompany: string, userId: string) {
    mixpanel.identify(userId);
    mixpanel.people.set({
      $name: userName,
      $company: userCompany,
      $email: userId,
    });
    mixpanel.track('$login', {
      $user_id: userId,
      $name: userName,
      $company: userCompany,
      $email: userId,
      event_time: formatDate(new Date()),
    });
  }

  pageView(pageTitle: string, urlPath: string) {
    mixpanel.track('$mp_web_page_view', {
      current_page_title: pageTitle,
      current_url_path: urlPath,
      event_time: formatDate(new Date()),
    });
  }
  tokenPageView(pageTitle: string, urlPath: string) {
    mixpanel.track('$mp_web_page_view', {
      current_page_title: pageTitle,
      current_url_path: urlPath,
      has_token:
        localStorage.getItem('USER_HAS_TOKEN') === 'true' ? `true` : `false`,
      event_time: formatDate(new Date()),
    });
  }

  reportVisualization(reportName: string) {
    mixpanel.track('$report_visualization', {
      selected_report: reportName,
      event_time: formatDate(new Date()),
    });
  }
  reportDetailVisualization(reportItemName: string, reportItemUrl?: string) {
    mixpanel.track('$report_detail_visualization', {
      report_item_name: reportItemName,
      report_item_url: reportItemUrl,
      event_time: formatDate(new Date()),
    });
  }
}
